import React from "react";
import { Modal } from "react-bootstrap";
import { FiX } from "react-icons/fi";

function Exco1({ show, onClose, onOpen }) {
  return (
    <div>
      <div>
        <Modal
          size="lg"
          show={show}
          onHide={onClose}
          // backdrop="static"
          aria-labelledby="example-modal-sizes-title-lg"
          keyboard={false}
          animation={true}
          centered
        >
          <Modal.Body>
            <div className="Solera__Cont">
              <FiX className="Solera__Close" onClick={onClose} />
            </div>

            <div className="Exoc-Name">Sam Onigbanjo</div>
            <div className="Exco-Tittle">Vice-president 1</div>
            <br />

            <div className="Excos-Bio">
              Sam Onigbanjo currently serves as the Vice President of the
              University of Lagos Alumni in the United Kingdom. As a dedicated
              Pan-Africanist, he is committed to action-oriented initiatives
              that enhance the African community. In his role as Vice President,
              Sam has been instrumental in launching several groundbreaking
              initiatives for the alumni association. These include establishing
              the alumni’s first social media presence, initiating the first
              student mentoring scheme, creating the inaugural "Employ a Unilag
              Undergraduate" program, and organizing the first Business,
              Investments, and Education Online Summits. His efforts have
              significantly enriched the community by providing valuable
              resources and support to current students and graduates alike.
              <br />
              <br />
              Beyond these initiatives, Sam supports and collaborates with other
              executive committee members to promote their projects and
              contribute to the alumni’s collective goals. Outside of his duties
              with the University of Lagos Alumni, Sam is the founder of Great
              Business Platforms, a global agency specializing in AI and digital
              marketing. He is also an accomplished author, having penned "37
              Business Thoughts" and "The ABCs of AI for Entrepreneurs," which
              provide strategic insights for business leaders.
              <br />
              <br /> With his Business Partner, Sam also co-founded the Capital
              Markets Academy, an online forex and stocks education company.
              Till date they have trained , equipped and graduated over 400
              professional students, who have another chance to create further
              streams of income and fulfil their personal dreams and goals.
              <br />
              <br />
              In addition to his professional pursuits, Sam plays a vital role
              in the wider African community in the UK. He and his wife are the
              conveners of Women4Africa, the largest and most successful African
              awards event in the UK, which annually gathers over 1,000 African
              women from around the globe. Sam’s prowess as a public speaker and
              his passionate advocacy for African development have made him a
              prominent figure in promoting and celebrating the achievements of
              African individuals and communities across the UK.
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default Exco1;
